import React from 'react'
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        backgroundColor: "black",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div style={{ display: "flex", gap: "20px" }}>
        <Link to={"/login"}>
          <div style={{ padding: "10px", color: "white", cursor: "pointer" }}>
            <p>Admin Login</p>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default Footer
